


























































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import UserQuestion from '../../../api/v2/models/user_question'
import LessonRelative from '../../../api/v2/models/lesson_relative'
import CourseRelative from '../../../api/v2/models/course_relative'
import api from '../../../api/v2/api'
import Pagination from '../../../api/v2/models/pagination'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import QuestionList from '../organisms/QuestionList.vue'
import { checkMobile } from '../../utils/utils'
import UserQuestionDialog from '../organisms/UserQuestionDialog.vue'
import { UserQuestionListForm } from '../../../api/v2/forms/user_question'
import { userQuestionState } from '../../stores/user_quetions'
import { headerState } from '../../stores/header'

@Component({
  components: {
    Simplemde,
    QuestionList,
    UserQuestionDialog,
  }
})
export default class UserQuestionListPage extends Vue {
  title: string = 'すべての質問'
  questions: UserQuestion[] = []
  userQuestionListForm: UserQuestionListForm
  pagination: Pagination
  isLoading: boolean = true
  search = ''
  searchCourse = ''
  model: string = ''
  modelCourse: string = ''
  items: string[] = []
  courseItems: string[] = []
  showSideBar: boolean = false
  page = 1
  mobile = checkMobile()
  currentCourse: CourseRelative | null = null
  showCourses: CourseRelative[] = []
  sideBarData: {
    sameLessonQuestions: UserQuestion[],
    sameCourseLessons: LessonRelative[],
    courses: CourseRelative[]
  } = {
    sameLessonQuestions: [],
    sameCourseLessons: [],
    courses: []
  }
  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: 'みんなの質問',
      disabled: false,
      exact: true,
      to: '/classroom/questions'
    }
  ]

  get getPbMobile() {
    return this.mobile ? "pb-10" : ""
  }

  async created() {
    headerState.setTitle('みんなの質問')
    this.userQuestionListForm = new UserQuestionListForm()
    
    await this.getList()

    if (this.questions.length > 0) {
      await this.loadSidebar()
    }
  }

  mounted() {
    this.$root.$on('questionCreated', this.refreshList)
  }

  @Watch('search')
  async watchSearch(){
    try {
      this.userQuestionListForm.search = this.search
      await this.getList()
    } catch (e) {
    } finally {
      this.isLoading = false
    }
  }

  @Watch('searchCourse')
  watchSearchCourse() {
    if (this.searchCourse != null && this.searchCourse.length > 0){
      this.showCourses = this.sideBarData.courses.filter((course) => course.name.includes(this.searchCourse));
    } else {
      this.showCourses = this.sideBarData.courses
    }
  }

  selectPage(page: number) {
    this.userQuestionListForm.page = page
    this.getList()
  }

  async loadSidebar() {
    try {
      this.sideBarData = await api.userQuestion.relativeLists(this.questions[0].id.toString())
      this.showCourses = this.sideBarData.courses
    } catch(e) {
    } finally {
    }
  }

  refreshList() {
    this.$router.replace({ 'query': {} })
    this.isLoading = true
    this.getList()
  }

  async getList() {
    if (this.$route.query.course_id) {
      this.userQuestionListForm.relativeableType = 'Course'
      this.userQuestionListForm.relativeableId = Number(this.$route.query.course_id)
    } else if (this.$route.query.lesson_id) {
      this.userQuestionListForm.relativeableType = 'Lesson'
      this.userQuestionListForm.relativeableId = Number(this.$route.query.lesson_id)
    } else {
      this.userQuestionListForm.relativeableType = undefined
      this.userQuestionListForm.relativeableId = undefined
    }

    try {
      [this.pagination, this.questions] = await userQuestionState.fetchList(this.userQuestionListForm)
      if (this.$route.query.course_id) {
        const course = await api.course.show(this.$route.query.course_id as string)
        this.title = `${course.name}の質問`
      } else if (this.$route.query.lesson_id) {
        const lesson = await api.lesson.show({ lessonId: this.$route.query.lesson_id as string }, "list")
        this.title = `${lesson.name}の質問`
      }
    } catch (e) {
    } finally {
      this.isLoading = false
    }
  }

  async clearSearch() {
    if (this.search) {
      [this.pagination, this.questions] = await userQuestionState.fetchMyList()
      this.search = ''
    }
  }

  @Watch('$route')
  changeRoute(val, oldVal) {
    this.getList()
  }
}
